<h1>Course Packages</h1>
<app-dynamic-content *ngIf="!ucdService.IsLoggedIn" blocktitle="My Package List Header - Anonymous">
</app-dynamic-content>
<app-dynamic-content *ngIf="ucdService.IsLoggedIn"
  blocktitle="My Package List Header - {{lmsUserService.User.GetMemberTypes('ABMP').shift()}}">
</app-dynamic-content>

<ng-container *ngIf="ucdService.IsLoggedIn">
  <h2>My Packages</h2>
  <ng-container *ngIf="((ucdService.Bundles$ | async) | bundleList:true:false) as bundles; else loadingBundles">
    <ng-container *ngIf="bundles.length > 0; else noMyBundles">
      <div *ngFor="let bundle of bundles">
        <h3>{{bundle.title}}</h3>
        <a class="bundletitle d-block" routerLink="/package/{{bundle.alias}}">
          <em *ngIf="bundle.CanPurchase && !bundle.Access">Available for purchase</em>
          <em *ngIf="bundle.Access && bundle.Expires">Valid through {{bundle.Expires | date:'mediumDate'}}</em>
          <em *ngIf="bundle.Access && !bundle.Expires">Purchased</em>
        </a>
        <p [innerHTML]="bundle.description"></p>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<h2>Available Packages</h2>
<ng-container *ngIf="((ucdService.Bundles$ | async) | bundleList:false:true) as bundles; else loadingBundles">
  <ng-container *ngIf="bundles.length > 0; else noBuyBundles">
    <div *ngFor="let bundle of bundles">
      <h3>{{bundle.title}}</h3>
      <a class="bundletitle d-block" routerLink="/package/{{bundle.alias}}">
        <em *ngIf="bundle.CanPurchase && !bundle.Access">Available for purchase</em>
        <em *ngIf="bundle.Access && bundle.Expires">Valid through {{bundle.Expires | date:'mediumDate'}}</em>
        <em *ngIf="bundle.Access && !bundle.Expires">Purchased</em>
      </a>
      <p [innerHTML]="bundle.description"></p>
    </div>
  </ng-container>
</ng-container>


<ng-template #noMyBundles>
  <app-dynamic-content blocktitle="No Active Packages"></app-dynamic-content>
</ng-template>
<ng-template #noBuyBundles>
  <app-dynamic-content blocktitle="No Packages to Buy"></app-dynamic-content>
</ng-template>
<ng-template #loadingBundles>
  <app-load-indicator description="available packages"></app-load-indicator>
</ng-template>